import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'
import { CommunicationsCampaignsRouter } from './campaigns/_router'

const Index = lazy(() => import('./Index'))

export const CommunicationsRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--communications']}>
    <Route index element={<Index />} />
    <Route path='campaigns/*' element={<CommunicationsCampaignsRouter />} />
  </SubRouter>
))
